<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>User Management</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/users' }">Users</el-breadcrumb-item>
                <el-breadcrumb-item v-if="!userId">New User</el-breadcrumb-item>
                <el-breadcrumb-item v-else>Edit User</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="16">
                <div class="main-title" v-if="!userId">
                    Create New User
                </div>
                <div class="main-title" v-else>
                    Edit User
                </div>

            </el-col>
            <el-col :span="8" class="text-right">
                <el-button type="success" size="small" @click="saveUser" v-loading="saving" v-if="!userId">Create User</el-button>
                <el-button type="success" size="small" @click="saveUser" v-loading="saving" v-else>Update User</el-button>
            </el-col>
        </el-row>
        <el-row :gutter=20  justify="space-between" class="mb-4 " style="margin-top: 24px" v-loading="saving">
            <el-form :rules="rules" ref="form" :model="form"  status-icon >
                <el-col :span="12">
                    <div class="container">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>User Information</span>
                            </div>
                            <div  class="text item">
                                <el-form-item label="Email" prop="email" label-width="100px">
                                    <el-input type="email" v-model="form.email" @change="emailChanged()"></el-input>
                                </el-form-item>
                                <el-form-item label="First Name" prop="firstName" label-width="100px">
                                    <el-input type="text" v-model="form.firstName"></el-input>
                                </el-form-item>
                                <el-form-item label="Last Name" prop="lastName" label-width="100px">
                                    <el-input type="text" v-model="form.lastName"></el-input>
                                </el-form-item>
                                <el-form-item label="Staff ID" prop="staffId" label-width="100px">
                                    <el-input type="text" v-model="form.staffId" @change="staffIDChanged()" :disabled="userId"></el-input>
                                </el-form-item>
                                <el-form-item label="Office" prop="office" label-width="100px">
                                    <el-select
                                            style="width: 100%"
                                            value-key="id"
                                            v-model="form.office"
                                            filterable
                                            remote
                                            placeholder="Select Office"
                                            :remote-method="searchOffice"
                                            :loading="searchingOffice">
                                        <el-option
                                                v-for="item in offices"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Department" prop="department" label-width="100px">
                                    <el-select
                                            style="width: 100%"
                                            value-key="id"
                                            v-model="form.department"
                                            filterable
                                            remote
                                            placeholder="Select Department"
                                            :remote-method="searchDepartment"
                                            :loading="searchingDepartment">
                                        <el-option
                                                v-for="item in departments"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Job Title" prop="jobTitle" label-width="100px">
                                    <el-input type="text" v-model="form.jobTitle"></el-input>
                                </el-form-item>
                                <el-form-item label="Password" prop="password" label-width="100px">
                                    <el-input v-model="form.password"></el-input>
                                </el-form-item>
                                <el-form-item label="Active" label-width="100px">
                                    <el-switch v-model="form.active"></el-switch>
                                </el-form-item>
                            </div>
                        </el-card>
                    </div>
                </el-col>
                <el-col :span="12" >

                    <div class="container">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>User Role Setting</span>
                            </div>
                            <div class="text item">
                                <el-form-item prop="role" >
                                    <el-select
                                            style="width: 100%"
                                            value-key="id"
                                            v-model="form.role"
                                            filterable
                                            remote
                                            placeholder="Select Role"
                                            :remote-method="searchRole"
                                            :loading="searchingRole">
                                        <el-option
                                                v-for="item in roles"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-card>
                    </div>
                    <div class="container">
                    <el-card class="box-card" style="margin-top: 20px;">
                        <div slot="header" class="clearfix">
                            <span>SR Country Data Access Right</span>
                        </div>
                        <div class="text item">
                            <el-select
                                    style="width: 100%"
                                    value-key="id"
                                    v-model="form.srCountries"
                                    filterable
                                    remote
                                    multiple
                                    placeholder="Select SR Country"
                                    :remote-method="searchSRCountry"
                                    :loading="searchingSRCountry">
                                <el-option
                                        v-for="item in srCountries"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </el-card>
                    </div>
                </el-col>
            </el-form>
        </el-row>
    </el-main>
</template>

<script>
import api from '@/services/api/WRCService'
import _ from 'lodash'

export default {
    props: ['userId'],
    data: function() {
        var validateEmail = (rule, value, callback) => {
            if (this.emailUsed == true) {
                callback(new Error('This Email already exist in database'));
            } else {
                
                callback();
            }
        }
        var validateStaffID = (rule, value, callback) => {
            if (this.staffIDUsed == true) {
                callback(new Error('This Staff ID already exist in database'));
            } else {
                
                callback();
            }
        }
        return {
            loading: false,
            saving: false,
            departments: [],
            //countries: [],
            //cities: [],
            rules: {
                firstName: [
                    {required: true, message: "Please enter first name", trigger: 'blur'}
                ],
                email: [
                    {required: true, message: 'Please enter email', trigger: 'blur'},
                    { validator: validateEmail, trigger: 'blur' }
                ],
                staffId: [
                    {required: true, message: 'Please enter staff id', trigger: 'blur'},
                    { validator: validateStaffID, trigger: 'blur' }
                ],
                // country: [
                //     {required: true, message: 'Please select country', trigger: 'blur'}
                // ],
                office: [
                    {required: true, message: 'Please select office', trigger: 'blur'}
                ],
                department: [
                    {required: true, message: 'Please select department', trigger: 'blur'}
                ],
                password: [
                    {required: _.isUndefined(this.userId), message: 'Please enter password', trigger: 'blur'}
                ],
                role: [
                    {required: true, message: 'Please select user role', trigger: 'blur'}
                ]
            },
            offices: [],
            srCountries: [],
            emailUsed: false,
            staffIDUsed: false,
            roles: [],
            form: {
                password: '',
                staffId: '',
                email: '',
                firstName: '',
                lastName: '',
                //country: '',
                //city: '',
                office: '',
                department: '',
                jobTitle: '',
                role: '',
                active: true,
                srCountries: ''
            },
            searchingCountry: false,
            searchingSRCountry: false,
            searchingCity: false,
            searchingOffice: false,
            searchingDepartment: false,
            searchingRole: false,
        }
    },
    computed: {
        cityPlaceholder() {
            if (this.form.country === '') {
                return 'Please select Country first'
            } else {
                return 'Select City'
            }
        }
    },
    methods: {
        saveUser() {
            this.emailUsed = false
            this.staffIDUsed = false

            this.$refs['form'].validate((valid) => {
                if (valid) {
                    let params = {
                        firstName: this.form.firstName,
                        lastName: this.form.lastName,
                        email: this.form.email,
                        staffId: this.form.staffId,
                        password: this.form.password,
                        jobTitle: this.form.jobTitle,
                        //cityId: this.form.city.id,
                        officeNameId: this.form.office.id,
                        departmentId: this.form.department.id,
                        roleId: this.form.role.id,
                        active: this.form.active,
                        accessCountries: []
                    }

                    if (!_.isUndefined(this.form.srCountries)) {
                        this.form.srCountries.forEach(srCountry => {
                            params.accessCountries.push(srCountry.id)
                        })
                    }

                    this.saving = true

                    if (!_.isUndefined(this.userId)) {
                        params.userId = this.userId
                        api.updateUser(params).then(() => {
                            this.$message({
                                message: 'Successfully Updated User.',
                                type: 'success'
                            });

                            this.$router.push('/users')
                        }).catch((error) => {
                            
                        }).then(() => {
                            this.saving = false;
                        });
                    } else {
                        api.createUser(params).then(() => {
                            this.$message({
                                message: 'Successfully registered new User.',
                                type: 'success'
                            });

                            this.$router.push('/users')
                        }).catch((error) => {
                            if (error.response.status == '400') {

                                var message = error.response.data.error.errors[0].message

                                if (error.response.data.error.errors[0].reason === 'EP001') {
                                    this.emailUsed = true

                                    this.$refs.form.validateField('email');
                                }

                                if (error.response.data.error.errors[0].reason === 'EP002') {
                                    this.staffIDUsed = true

                                    this.$refs.form.validateField('staffId');
                                }

                                

                                this.$message({
                                    type: 'error',
                                    showClose: true,
                                    message
                                });
                            }
                        }).then(() => {
                            this.saving = false;
                        });
                    }
                }
            })
        },
        searchCountry(query) {
            this.searchingCountry = true;

            api.getCountries(query, {
                page: 0,
                size: 100
            }).then(({ data }) => {

                this.countries.splice(0, this.countries.length);
                this.countries.push(...data.data.items);
                //this.pagination.total = data.total;
                //this.pagination.currentPage = data.currentPage;
            }).catch(() => {}).then(() => {
                this.searchingCountry = false;
            });
        },
        searchSRCountry(query) {
            this.searchingSRCountry = true;

            api.getSRCountries(query, {
                page: 0,
                size: 100
            }, true).then(({ data }) => {

                this.srCountries.splice(0, this.srCountries.length);
                this.srCountries.push(...data.data.items);
                //this.pagination.total = data.total;
                //this.pagination.currentPage = data.currentPage;
            }).catch(() => {}).then(() => {
                this.searchingSRCountry = false;
            });
        },
        countrySelected(value) {
            if (this.form.city !== '') {
                this.form.city = ''
            }
            this.searchCity('')
        },
        searchCity(query) {
            if (this.form.country !== '') {
                this.searchingCity = true;

                api.getCities({
                    name: query,
                    countryId: this.form.country.id
                }, {
                    page: 0,
                    size: 100
                }).then(({data}) => {

                    this.cities.splice(0, this.cities.length);
                    this.cities.push(...data.data.items);
                    //this.pagination.total = data.total;
                    //this.pagination.currentPage = data.currentPage;
                }).catch(() => {
                }).then(() => {
                    this.searchingCity = false;
                });
            }
        },
        searchOffice(query) {
            this.searchingOffice = true;

            api.getOffices(query, {
                page: 0,
                size: 100
            }, true).then(({ data }) => {

                this.offices.splice(0, this.offices.length);
                this.offices.push(...data.data.items);
                //this.pagination.total = data.total;
                //this.pagination.currentPage = data.currentPage;
            }).catch(() => {}).then(() => {
                this.searchingOffice = false;
            });
        },
        searchDepartment(query) {
            this.searchingDepartment = true;

            api.getDepartments(query, {
                page: 0,
                size: 100
            }, true).then(({ data }) => {

                this.departments.splice(0, this.departments.length);
                this.departments.push(...data.data.items);
                //this.pagination.total = data.total;
                //this.pagination.currentPage = data.currentPage;
            }).catch(() => {}).then(() => {
                this.searchingDepartment = false;
            });
        },
        searchRole(query) {
            this.searchingRole = true;

            api.getRoles(query, {
                page: 0,
                size: 100
            }, true).then(({ data }) => {

                this.roles.splice(0, this.roles.length);
                this.roles.push(...data.data.items);
                //this.pagination.total = data.total;
                //this.pagination.currentPage = data.currentPage;
            }).catch(() => {}).then(() => {
                this.searchingRole = false;
            });
        },
        emailChanged() {
            this.emailUsed = false
        },
        staffIDChanged() {
            this.staffIDUsed = false
        },
    },
    mounted() {
        //this.searchCountry('')
        this.searchSRCountry('')
        this.searchOffice('')
        this.searchDepartment('')
        this.searchRole('')

        if (!_.isUndefined(this.userId)) {

            this.saving = true
            api.getUser(this.userId).then(({data}) => {
                let user = data.data

                this.form.staffId = user.staffID
                this.form.email = user.email
                this.form.firstName = user.firstName
                this.form.lastName = user.lastName
                //this.form.country = user.city.country
                //this.form.city = user.city
                this.form.office = user.office
                this.form.department = user.department
                this.form.jobTitle = user.jobTitle
                this.form.active = user.active
                this.form.srCountries = user.countries
                this.form.role = user.role

                //this.searchCity('')
                //this.searchOffice('')
            }).catch(() => {}).then(() => {
                this.saving = false
            })
        }
    }
}
</script>

<style scoped>
</style>